import type { EligibleQuotaInvoice } from "~/modules/quota/api/quota/quotaTypes.ts";
import { formatQuotaInvoiceProjectLabel } from "~/modules/quota/utils/quotaInvoiceUtils.ts";
import { formatCentsToCurrency } from "~/utils/currencyUtils.ts";
import { formatSmartDateRange, parseDateString } from "~/utils/dateAndTimeUtils.ts";

type Props = {
	invoice: EligibleQuotaInvoice;
};

// The three-line display of one invoice for an invoice-backed quota. It is one grid: the left
// column truncates, the amount column is right aligned, and the label column has a fixed width,
// so the amounts align across all invoices in a list.
export const QuotaInvoiceSummary = ({ invoice }: Props) => {
	return (
		<div className="grid min-w-0 flex-1 grid-cols-[minmax(0,1fr)_auto_6.5rem] items-baseline gap-x-2 gap-y-1 text-left text-sm">
			<div className="mr-2 truncate font-medium">{invoice.invoiceNumber ?? "Ohne Rechnungsnummer"}</div>
			<div className="text-right tabular-nums">{formatCentsToCurrency(invoice.subtotalCents)}</div>
			<div className="text-gray-500">Netto-Betrag</div>

			<div className="mr-2 truncate text-gray-500">
				{invoice.projectId !== null ? formatQuotaInvoiceProjectLabel(invoice) : "Ohne Projekt"}
			</div>
			<div className="text-right tabular-nums">{formatCentsToCurrency(invoice.totalTrackedCents)}</div>
			<div className="text-gray-500">Erfassungen</div>

			<div className="mr-2 truncate text-gray-500">
				{formatSmartDateRange(parseDateString(invoice.deliveryStartDate), parseDateString(invoice.deliveryEndDate))}
			</div>
			<div className="text-right font-bold tabular-nums">{formatCentsToCurrency(invoice.excessCents)}</div>
			<div className="font-bold">Überschuss</div>
		</div>
	);
};
